import {
  createDeploymentUpdateAddRoute,
  ALLOCATION_HISTORY,
} from 'adminConstants/routes';
import FullPageSuccess from 'components/FullPageSuccess';
import { useUploadAllocations } from 'hooks/data/allocation/useUploadAllocations';
import ButtonAsText from 'components/ButtonAsText';
import useCompany from 'hooks/data/company/useCompany';
import { CalendarDay } from 'further-ui/utils';

type SuccessPageProps = {
  selectedCompanyId: string;
  shareAllocationUploadId: string;
  allocationDate?: CalendarDay;
};

const SuccessPage: React.FC<SuccessPageProps> = ({
  selectedCompanyId,
  shareAllocationUploadId,
  allocationDate,
}) => {
  const { exportToCustodian } = useUploadAllocations();
  const { data: company } = useCompany(selectedCompanyId);

  const handleExportToCustodian = () => {
    exportToCustodian.mutate({
      shareAllocationUploadId,
      companyTradingName: company?.tradingName ?? undefined,
      allocationDate: allocationDate?.toUTCDate(),
    });
  };

  return (
    <FullPageSuccess
      title="Your shares have been allocated successfully"
      additionalText="Your investors will now be able to view this shareholding in their investor portals. Would you like to send a deployment update?"
      proceedText="Send deployment update"
      proceedLink={createDeploymentUpdateAddRoute(
        shareAllocationUploadId,
        selectedCompanyId,
      )}
      bottomText={
        <i>
          If you don't send a deployment update now, you can do it later by
          navigating to the Allocations section and clicking the mail icon next
          to the relevant company.{' '}
          <ButtonAsText
            variant="text"
            onClick={handleExportToCustodian}
            disabled={exportToCustodian.isPending}
            size="small"
          >
            <i>Click here </i>
          </ButtonAsText>{' '}
          to download a custodian transfer statement relating to this
          allocation.
        </i>
      }
      secondaryText="Do this later"
      secondaryLink={ALLOCATION_HISTORY}
      isFullPage={false}
    />
  );
};

export default SuccessPage;
